var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInviteSearchActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon",
    className: "st0",
    d: "M8.9,15.4c-3.6,0-6.5-2.9-6.5-6.5s2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5S12.5,15.4,8.9,15.4L8.9,15.4z  M18,15.7l-1.5-0.1l-0.2-1.9c2.2-3.4,1.8-8.1-1.2-11.1c-3.5-3.5-9.1-3.5-12.5,0c-3.5,3.5-3.5,9.1,0,12.6c3,3,7.7,3.4,11.1,1.2l2,0.1 l0,1.5l5.2,6h1.5l1.5-1.5V21L18,15.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteSearchActive);
export default __webpack_public_path__ + "static/media/invite_search_active.f6e3943f165ab2463d207695c7bda55f.svg";
export { ForwardRef as ReactComponent };